import React, { useState, useEffect } from "react";
//import "./styles.css";
// import { Row, Col, Form } from "react-bootstrap";
// import LeftpanelAdmin from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import LoadingOverlay from "react-loading-overlay";
import "./viewlik.css";
import DataTable from "react-data-table-component";
// import { AddIcon, DeleteIcon } from "../../../assets/images";
// export default class AddLink extends Component {
//     render() {
//         return (
//           <div className="home_new">
//                <AddLinkPart />
//           </div>
//         );
//       }
// }
import axios from "../../../axios/axios";
import { message } from "antd";
import { adminConfig } from "../../../utils/adminConfig";
const columns = [
  {
    name: " Name",
    selector: (row) => row.name,
    sortable: true,
    width: "300px",
  },
  {
    name: "URL",
    selector: (row) => row.link,
    sortable: true,
    width: "400px",
  },
  {
    name: "Portal",
    selector: (row) => row.portal,
    sortable: true,
    width: "300px",
  },
  {
    name: "Action",
    selector: (row) => row.action,
    sortable: true,
    width: "240px",
  },
];

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const AddLinkPart = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const allLinks = () => {
    let allMembers = links.map((item, i) => {
      return {
        id: i + 1,
        link: item.link,
        name: item.name,
        portal: item.portal,

        action: (
          <div className="action_block">
            <button
              type="button"
              className="edit_but"
              onClick={() => updateLink(item._id)}
            >
              Reset Link
            </button>
            {/* <button type="button" className="delete_but">
              Delete
            </button> */}
          </div>
        ),
      };
    });
    return allMembers;
  };
  const getLink = () => {
    setLoading(true);
    axios
      .get(`/get-links`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          setLinks(res.data.data);
          // setPagination(res.data.pagination);
          // console.log("pagination", res.data.pagination);
          setLoading(false);
          message.success("link fetched");
        } else {
          message.error("failed fetching member");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  const updateLink = (id) => {
    setLoading(true);

    let payload = {
      id,
      active: false,
      link: "/coming-soon",
    };
    axios
      .patch(`/update-link`, payload, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          getLink();
          setLoading(false);
          message.success("link fetched");
        } else {
          message.error("failed fetching member");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getLink();
  }, []);
  return (
    // <div>
    <LoadingOverlay active={loading} spinner text="loading...">
      {/* <HeaderPart />
        <div className="main_cont">
          <LeftpanelAdmin /> */}
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <h4>View Link</h4>
            <div className="view_link_table">
              <DataTable
                columns={columns}
                data={allLinks()}
                pagination
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
              />
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
    </LoadingOverlay>
    //  </div>
  );
};

export default AddLinkPart;
